/* global window */
/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import { HTTP_204_NO_CONTENT, HTTP_403_FORBIDDEN } from 'consts/http';
import { PENDING, SUCCESSFUL, FAILED, ERROR } from 'consts/requestStates';
import { setSelectionState } from 'reducers/courseDependencies';
import { apiRequest, encodeFiles, resolveWith } from 'utils';

export const SET_REQUEST_STATE = 'SET_REQUEST_STATE';
export function setRequestState(actionSet, state, data, tag) {
  return { type: SET_REQUEST_STATE, payload: { actionSet, state, data, tag } };
}

export const RESET_REQUEST_STATE = 'RESET_REQUEST_STATE';
export function resetRequestState(actionSet, tag) {
  return { type: RESET_REQUEST_STATE, payload: { actionSet, tag } };
}

export const SET_REQUEST_ERROR = 'SET_REQUEST_ERROR';
export function setRequestError() {
  return { type: SET_REQUEST_ERROR };
}

export const CLEAR_REQUEST_ERROR = 'CLEAR_REQUEST_ERROR';
export function clearRequestError() {
  return { type: CLEAR_REQUEST_ERROR };
}

export const SET_PENDING_UPLOAD_IN_FORM = 'SET_PENDING_UPLOAD_IN_FORM';
export function setPendingUploadInForm(form, field, file) {
  return { type: SET_PENDING_UPLOAD_IN_FORM, payload: { form, field, file } };
}

const SESSION_EXPIRED_MESSAGE = 'Authentication credentials were not provided.';

export function makeHttpRequest(actionSet, url, method, data, metaData, tag) {
  return (dispatch) => {
    const meta = Object.assign({}, metaData, { tag });
    dispatch({ type: actionSet.REQUEST, meta });
    dispatch(setRequestState(actionSet, PENDING, null, tag));

    return encodeFiles(data || {})
      .then(transformedData => apiRequest(url, method, transformedData))
      .catch((error) => {
        dispatch({ type: actionSet.FAILURE, payload: error, meta });
        dispatch(setRequestState(actionSet, ERROR, error, tag));
        dispatch(setRequestError());
        return Promise.reject();
      })
      .then(
        response =>
          (response.status === HTTP_204_NO_CONTENT ? resolveWith(null) : response.json())
            .catch((error) => {
              dispatch({ type: actionSet.FAILURE, payload: error, meta });
              dispatch(setRequestState(actionSet, ERROR, error, tag));
              dispatch(setRequestError());
              return Promise.reject();
            })
            .then((json) => {
              const { ok, status } = response;
              if (status === HTTP_403_FORBIDDEN &&
                json.detail === SESSION_EXPIRED_MESSAGE &&
                (!metaData || !metaData.dontTimeout)
              ) {
                window.location = '/login/timeout/'; // Only way to programmatically redirect with React Router 4
              } else {
                dispatch({
                  type: (ok ? actionSet.SUCCESS : actionSet.FAILURE),
                  payload: json,
                  meta,
                });
                dispatch(setRequestState(actionSet, (ok ? SUCCESSFUL : FAILED), json, tag));
              }
              return ok ? response : Promise.reject();
            }),
      );
  };
}

export const SET_TENANT_PASS_SELECTIONS = 'SET_TENANT_PASS_SELECTIONS';
export function setTenantPassSelections(courseList, selectedItemIds, isSelected) {
  // Precalculate the result in here, as multiple
  // reducers need access to this data
  return {
    type: SET_TENANT_PASS_SELECTIONS,
    payload: setSelectionState(courseList, selectedItemIds, isSelected),
  };
}

export const CLEAR_COURSE_SELECTION_CACHE = 'CLEAR_COURSE_SELECTION_CACHE';
export function clearCourseSelectionCache() {
  return {
    type: CLEAR_COURSE_SELECTION_CACHE,
  };
}
